import {
  getAction,
  deleteAction,
  putAction,
  putparamsAction,
  postAction,
  httpAction,
} from "@/api/manage";
// 点巡检任务
const messDeviceCheckTaskQueryById = (params) =>
  getAction(`/mess/messDeviceCheckTask/queryById?id=${params}`); // 详情
const messDeviceCheckTaskAdd = (params) =>
  postAction("/mess/messDeviceCheckTask/add", params); // 新建检查
const messDeviceCheckTaskReport = (params) =>
  postAction("/mess/messDeviceCheckTask/report", params); // 汇报

//  设备台账
const messDeviceList = (params) => getAction("/mess/device/list", params);
// 点巡检项目
const messCheckItemList = (params) =>
  getAction("/mess/messCheckItem/list", params); // 列表


const getWarningNum = (params) => getAction('/wms/wmsReportForms/getWarningNum', params) // 月度库存收支统计

const queryProcessByOrderTaskId = (params) => getAction("/mess/messNotQualityHandleIinfo/queryProcessByOrderTaskId", params); // 不合格工序下拉


export const inspectionApi = {
  messDeviceCheckTaskQueryById,
  messCheckItemList,
  messDeviceList,
  messDeviceCheckTaskAdd,
  messDeviceCheckTaskReport,
  getWarningNum,
  queryProcessByOrderTaskId,
};
